import axios from "axios";
import {appVersion, APIServer} from "@/constants/config";

export async function checkServerVersion() {
  const response = await axios.get(APIServer + "/studentVersion");
  return String(response.data) === appVersion;
}

export const addCommas = nStr => {
    nStr += '';
    const x = nStr.split('.');
    let x1 = x[0];
    const x2 = x.length > 1 ? '.' + x[1] : '';
    const rgx = /(\d+)(\d{3})/;
    while (rgx.test(x1)) {
        x1 = x1.replace(rgx, '$1' + ',' + '$2')
    }
    return x1 + x2
};

export const mapOrder = (array, order, key) => {
    array.sort(function (a, b) {
        const A = a[key];
        const B = b[key];
        if (order.indexOf(A + '') > order.indexOf(B + '')) {
            return 1
        } else {
            return -1
        }
    });
    return array
};

export const getDateWithFormat = () => {
    const today = new Date();
    let dd = today.getDate();
    let mm = today.getMonth() + 1; // January is 0!

    const yyyy = today.getFullYear();
    if (dd < 10) {
        dd = '0' + dd
    }
    if (mm < 10) {
        mm = '0' + mm
    }
    return dd + '.' + mm + '.' + yyyy
};

export const getCurrentTime = () => {
    const now = new Date();
    return now.getHours() + ':' + now.getMinutes()
};

export const round = (number, decimalPlaces) => {
	// const x = 9999.8;                      // Your example
	// console.log(x * 100);                  // 999979.9999999999
	// console.log(x * 100 / 100);            // 9999.8
	// console.log(x / 100);                  // 99.99799999999999

	// const y = x*1000 ;                    // Your example scaled by 1000
	// console.log((y * 100) / 1000);        // 999980
	// console.log((y * 100 / 100) / 1000);  // 9999.8
	// console.log((y / 100) / 1000);        // 99.998

	const pow = 1000;
	const factorOfTen = Math.pow(10, decimalPlaces);
	number = number * pow;
  let convRound = Math.round((number * factorOfTen) / pow) / factorOfTen
	return (convRound < 0 ? 0 : convRound);
};

export const roundUp = (number, decimalPlaces) => {
	// const x = 9999.8;                      // Your example
	// console.log(x * 100);                  // 999979.9999999999
	// console.log(x * 100 / 100);            // 9999.8
	// console.log(x / 100);                  // 99.99799999999999

	// const y = x*1000 ;                    // Your example scaled by 1000
	// console.log((y * 100) / 1000);        // 999980
	// console.log((y * 100 / 100) / 1000);  // 9999.8
	// console.log((y / 100) / 1000);        // 99.998

	const pow = 1000;
	const factorOfTen = Math.pow(10, decimalPlaces);
	number = number * pow;
	return Math.ceil((number * factorOfTen) / pow) / factorOfTen;
};

export const percentage = (number, per) => {
	return (parseFloat(number) / 100) * per
}


export const paidAmountRemains = (remain, value) => {
	if (remain !== 0) {
		if (remain >= value) {
			return { remain: remain - value, value: 0 };
		} else {
			return { remain: 0, value: value - remain };
		}
	} else {
		return { remain: 0, value };
	}
};

export const paidAmountRemainsLimit = (remain, value, limit) => {
  let extra = 0
	if (limit === 0) {
		extra = limit;
	} else {
		if (limit >= value) {
			limit = value;
			value = 0;
		} else {
			value = value - limit;
		}
		if (limit >= remain) {
			limit = limit - remain;
			remain = 0;
		} else {
			remain = remain - limit;
			limit = 0;
		}
		extra = limit;
	}
	return { remain, value, extra };
};


export const paidTransactionDetail = (transaction) => {
  let principle = transaction.principle
  let paidFee = transaction.paidAccruedFee
  let paidPenalty = transaction.paidAccruedPenalty
  let paidInterest = transaction.paidAccruedInterest + transaction.balanceRemain
  let paidPrinciple = transaction.paidPrinciple
  let principleRemain = transaction.principleRemain

  if(paidPrinciple > principle) {
    paidInterest += (paidPrinciple-principle)
    paidPrinciple = principle
    principleRemain = 0
  }

  return {
    paidFee,
    paidPenalty,
    paidInterest,
    paidPrinciple,
    principleRemain
  }
};

export const momentSet = {
	zeroTime: {
		hour: 0,
		minute: 0,
		second: 0,
		millisecond: 0,
	},
	limitTime: {
		hour: 23,
		minute: 59,
		second: 59,
		millisecond: 999,
	},
};

export const isEmpty = (obj) => {
  return Object.keys(obj).length === 0;
};
